import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/customerPurchaseOrderQueries"

import {
  type CustomerPurchaseOrderProduct,
  GetCustomerPurchaseOrderProductsDocument,
  type GetCustomerPurchaseOrderProductsQuery,
} from "@/graphql/codegen/graphql"

interface UseGetCustomerPurchaseOrderProductsReturn {
  products: CustomerPurchaseOrderProduct[]
  isFetching: boolean
  hasFetched: boolean
}

// hasFetched (not isFetching) is what callers should gate a one-time form seed on — while paused,
// isFetching stays false and data stays undefined, which looks identical to "fetched, found none".
export const useGetCustomerPurchaseOrderProducts = (
  customerPurchaseOrderId: string,
  pause: boolean
): UseGetCustomerPurchaseOrderProductsReturn => {
  const [{ data, fetching }] = useQuery<GetCustomerPurchaseOrderProductsQuery>({
    query: GetCustomerPurchaseOrderProductsDocument,
    variables: { input: { customerPurchaseOrderId } },
    pause,
  })

  const output = data?.customerPurchaseOrder.get

  const products = useMemo<CustomerPurchaseOrderProduct[]>(() => {
    if (output?.__typename !== "CustomerPurchaseOrderGetSuccess") return []
    return output.customerPurchaseOrder.products as CustomerPurchaseOrderProduct[]
  }, [output])

  return { products, isFetching: fetching, hasFetched: data !== undefined }
}
